import { render, staticRenderFns } from "./ExecutiveTurnover.vue?vue&type=template&id=c5c5121c&scoped=true"
import script from "./ExecutiveTurnover.vue?vue&type=script&lang=js"
export * from "./ExecutiveTurnover.vue?vue&type=script&lang=js"
import style0 from "./ExecutiveTurnover.vue?vue&type=style&index=0&id=c5c5121c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c5121c",
  null
  
)

export default component.exports